import { createFileRoute, redirect } from "@tanstack/react-router";

// URL antigua: redirección permanente a la ruta limpia.
export const Route = createFileRoute("/termometro-lemon")({
  beforeLoad: () => {
    throw redirect({ to: "/detector-de-fugas", statusCode: 301 });
  },
});
